// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wake-turbulence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wake-turbulence/wake-turbulence.js';

mount([g0]);
